module.exports = __webpack_public_path__ + "static/welltreadhome-dbe6ba125fd7cc071efc9c4f46140356.png";